/**
 * Hash a chunk as expected for S3 multipart uploads
 *
 * see https://gist.github.com/jeantanzj/3c2269c203be17e20c1662373f89c532
 */
export async function hashMultipartChunk(chunk: Blob): Promise<string> {
  // Make a base64 encoded string from SHA-256 hash of the chunk
  return btoa(
    String.fromCharCode(
      ...new Uint8Array(await crypto.subtle.digest('SHA-256', await chunk.arrayBuffer())),
    ),
  );
}
